import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { useTranslation } from "react-i18next";

function VisaPrepUniEnrolmentStep3(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.APPLIED_THROUGH_UCAS}
        label={t('forms.visa:didYouApplyForYourCourseThroughU')}
        value={boolToYesNo(props.appliedThroughUCAS)}
      />
      {props.appliedThroughUCAS ? (
        <SummaryRow
          className={'visa-summary'}
          key={VQ.UCAS_PIN}
          value={props.ucasPin}
          label={t('forms.visa:whatIsYourUcasPersonalIdentifica')}
        />
      ) : null}
    </>
  );
}

export default VisaPrepUniEnrolmentStep3;
